import { KooperationspartnerDisplayModel } from "@/api/model-index";
import { ProjektbeteiligterService } from "@/api/service-index";
import { PortalContextService } from "@/core/services/portal-context.service";
import { UnfinishedHttpMethodsService } from "@/core/services/unfinished-http-methods.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class GetKooperationspartnerResolver {
    constructor(protected projektbeteiligteService: ProjektbeteiligterService, protected portalContextService: PortalContextService, protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService) { }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<KooperationspartnerDisplayModel[] | undefined> {
        let id: string = <string>route.params['id'];

        await this.unfinishedHttpMethodsService.waitByUrl(state.url);

        return this.projektbeteiligteService.apiProjektbeteiligterGetAllKooperationspartnerAnfrageIdGet({ anfrageId: id }).pipe(map(response => {
            if (response) {
                return response;
            }

            return undefined;
        })).toPromise();
    }
}